<template>
    <b-modal :modal-class="`modal-${variant} modal-min-btn`"
             ok-only
             v-model="isOpen"
             :title="title"
             hide-header-close
             no-close-on-backdrop
             centered
             @ok="onClick"
             :ok-title="okTitle"
             :ok-variant="variant"
             ref="modal">
        <slot>
            <div v-html="message"></div>
        </slot>
    </b-modal>
</template>

<script>
export default {
    name: "Alert",
    props: {
        modalProps: {},
        okTitle: {default: 'OK'},
        variant: {default: 'primary'},
        title: {default: 'Error'},
        message: {default: ''},
        open: false
    },
    data() {
        return {isOpen: false}
    },
    computed: {},
    watch: {
        open: function (newVal) {
            if (newVal) {
                this.isOpen = true;
            }
        }
    },
    methods: {
        show() {
            return new Promise((resolve) => {
                this.resolve = resolve;
                this.$refs.modal.show();
            })
        },
        onClick(e) {
            if (this.resolve) {
                this.resolve(e)
            }
        }
    }
}
</script>

<style scoped>

</style>
